// #region import
import axios from 'axios';
import {
  RUNNING_TYPE,
  RUNNING_TYPE_MASTER,
  RUNNING_TYPE_DEVELOP,
  PUSH_SEND_API_URL,
  PUSH_SEND_API_DEV_URL,
  API_KEY,
  API_KEY_RC_TEST,
  RUNNING_TYPE_LOCAL,
  PUSH_SEND_API_LOCAL_URL,
} from '../util/Const';
// #endregion import

// #region dto
/**
 * 通知送信APIリクエストIF
 */
export type SendRequestDto = {
  title: string;
  message: string;
  author: string | null;
  device: string[];
  target: target[];
  url: String;
  type: Number;
  is_debug: Number;
};

// 対象地域
export type target = {
  city_code: Number;
  village_code: Number | undefined;
};

/**
 * 通知送信APIリクエスト
 * @param dto
 */
export const PostPushSend = async (dto: SendRequestDto) => {
  let url: string;
  let apiKey: string;
  switch (RUNNING_TYPE) {
    case RUNNING_TYPE_MASTER:
      url = PUSH_SEND_API_URL;
      apiKey = API_KEY;
      break;
    case RUNNING_TYPE_DEVELOP:
      url = PUSH_SEND_API_DEV_URL;
      apiKey = API_KEY_RC_TEST;
      break;
    case RUNNING_TYPE_LOCAL:
      url = PUSH_SEND_API_LOCAL_URL;
      apiKey = API_KEY_RC_TEST;
      break;
    default:
      url = '';
      apiKey = '';
      break;
  }

  if (
    RUNNING_TYPE === RUNNING_TYPE_MASTER ||
    RUNNING_TYPE === RUNNING_TYPE_DEVELOP ||
    RUNNING_TYPE === RUNNING_TYPE_LOCAL
  ) {
    const res = await axios
      .post(url, JSON.stringify(dto), {
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': apiKey,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw error;
      });
    return res;
  }

  console.info(url);
  console.info(JSON.stringify(dto));
  const res = 'response';
  return res;
};
